/*
axios 配置
 */
import axios from 'axios';
import router from '../router';
import {
    Loading, Message
} from 'element-ui';
// axios.defaults.baseURL = '';
const service = axios.create({
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json',
    }
})

service.interceptors.request.use(
    config => {
        let roleId = localStorage.getItem("roleId");
        let token = localStorage.getItem('token');
        if (token) config.headers.token = token;
        if (roleId) config.headers.roleId = roleId;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

service.interceptors.response.use(

    response => {
        return Promise.resolve(response.data);
    },
    error => {
        if (error == 'Error: timeout of 60000ms exceeded') {
            Message({ message: '请求超时，请稍后重试！', type: 'warning' })
        } else if (error && error.response) {
            // 根据错误码跳转到对应的页面
            switch (error.response.status) {
                case 401:
                    router.push('/error/401')
                    break;
                // case 404:
                //     router.push('/error/404')
                //     break;
                // case 500:
                //     router.push('/error/500')
                //     break;
                case 403:
                    localStorage.clear();
                    // localStorage.removeItem("token");
                    // localStorage.removeItem("userInfo");
                    console.log("登录页")
                    console.log(window.location)
                    if (window.location.hash.indexOf('/login') == -1) {
                        router.push("/login");
                    } else {
                        Message({ message: '暂无用户权限！', type: 'warning' })
                    }

                    break;
                default:
                    return Promise.reject(error);
            }
        } else {
            return Promise.reject(error);
        }
        // let loading = Loading.service({ fullscreen: true })
        // loading.close();
    }
)

export default service;
